module.exports = __webpack_public_path__ + "0f3f900d8a87702e37c4a2584e45c195.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/8.jpg
// module id = 529
// module chunks = 0